import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import SectionHeader from '../SectionHeader';

const OfferDetailsSection = ({
  hasExpanded = true,
  className,
  explanationOpen,
  title,
  explanationText,
  children,
}) => {
  const [myExplanationOpen, setMyExplanationOpen] = useState(explanationOpen);

  useEffect(() => {
    setMyExplanationOpen(explanationOpen);
  }, [explanationOpen]);

  return (
    <section className={className}>
      <SectionHeader
        hasExpanded={hasExpanded}
        expanded={myExplanationOpen}
        title={title}
        explanationText={explanationText}
      />
      {children}
    </section>
  );
};

OfferDetailsSection.propTypes = {
  className: PropTypes.string,
  explanationOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  explanationText: PropTypes.object.isRequired,
  children: PropTypes.node,
  hasExpanded: PropTypes.bool,
};

export default OfferDetailsSection;
